import { jsx as _jsx } from "react/jsx-runtime";
import { handleInlineEnter } from '../../routines/handleInlineEnter.js';
import { useCallback } from 'react';
export const Caption = ({ block, editor, onChange }) => {
    const handleChange = useCallback((event) => {
        onChange?.(event.target.value);
        event.target.style.height = 'auto';
        event.target.style.height = `${event.target.scrollHeight}px`;
    }, [onChange]);
    if (editor?.isEditable) {
        return (_jsx("textarea", { className: "contra-bn-caption", defaultValue: block.props.caption, onChange: handleChange, onKeyDown: (event) => {
                handleInlineEnter({ block, editor, event });
            }, placeholder: "Add a caption", rows: 1 }));
    }
    if (!block.props.caption) {
        return null;
    }
    return (_jsx("div", { className: "contra-bn-caption-readonly", children: block.props.caption }));
};
//# sourceMappingURL=Caption.js.map